<script setup lang="ts">
import {Icon} from "@iconify/vue";

const props = withDefaults(
	defineProps<{
		heading?: string
		text?: string
		defaultState?: boolean
		headingColor?: string
		textColor?: string
		background?: string
	}>(),
	{
		heading: '',
		text: '',
		defaultState: false,
		headingColor: 'text-color',
		textColor: 'text-color',
		background: '',
	},
)

const isOpen = ref(props.defaultState)
</script>

<template>
	<div
		class="grid grid-rows-[auto_0fr] transition-[grid-template-rows] duration-300"
		:class="{
			'grid-rows-[auto_1fr]': isOpen,
			'p-4': !!background,
		}"
		:style="{
			background,
		}"
	>
		<button
			class="flex items-center justify-between w-full text-left group"
			@click="isOpen = !isOpen"
		>
			<slot name="heading">
				<h3 :class="`text-xl font-semibold ${headingColor} my-0`">{{ heading }}</h3>
			</slot>

			<Icon
				icon="heroicons:chevron-down"
				:class="[
					`w-6 h-6 transform transition-transform duration-200 ${headingColor}`,
					{
						'rotate-180': isOpen,
					},
				]" />
		</button>

		<div class="overflow-hidden accordion-content">
			<slot name="text">
				<div :class="`!text-base md:!text-lg ${textColor} pt-4`" v-html="text"></div>
			</slot>
		</div>
	</div>
</template>

<style>
.accordion-content {
	ul {
		font: inherit !important;
		color: inherit;
		list-style-type: disc;
		padding-left: 2em;
	}

	li {
		font: inherit !important;
		color: inherit;
	}

	li:not(:last-child) {
		margin-bottom: 0.5rem;
	}

	a {
		color: inherit;
	}
}
</style>
